import React from 'react';
import { ControlLink } from '@moda/om';
import classNames from 'classnames';

import './ReturnPolicyHyperlink.scss';

export const ReturnPolicyHyperlink: React.FC<{ className?: string }> = ({
  children,
  className
}) => {
  if (!children) return null;

  return (
    <ControlLink
      className={classNames('ReturnPolicyHyperlink', className)}
      href="https://help.modaoperandi.com/hc/en-us/articles/211521863-Return-Policy"
      rel="noopener noreferrer"
      target="_blank"
    >
      {children}
    </ControlLink>
  );
};
